export enum TenantTsType {
    SKY = '1',
    ALP = '2',
    AMADEUS = '3',
    RATEHAWK = '4',
    DISCOVER = '5',
    GENERIC = '100',
}